import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default class Customize {
  constructor() {
    this.customizeCheckboxes = document.querySelectorAll(
      "[data-js='customize-checkbox']",
    );
    this.customizeElements = document.querySelectorAll(
      "[data-js='customize-element']",
    );
    this.scrollableContainer = document.querySelector(
      "[data-js='product-mobile-info']",
    );
    this.customizeTabMobile = document.querySelector(
      "[data-js='customize-tab-mobile']",
    );
    this.arrowButton = this.customizeTabMobile.querySelector(
      "[data-js='customize-arrow-mobile']",
    );
    this.isOpen = false;
  }

  init() {
    this.customizeCheckboxes.forEach((checkbox, index) => {
      const customizeElement = this.customizeElements[index];
      const regularFontButton = customizeElement.querySelector(
        "[data-js='customize-element__isRegular']",
      );
      const cursiveFontButton = customizeElement.querySelector(
        "[data-js='customize-element__isCursive']",
      );
      const inputsWrapper = customizeElement.querySelector(
        "[data-js='inputs-wrapper']",
      );
      const firstInput = customizeElement.querySelector(
        "[data-js='first-input']",
      );
      const secondInput = customizeElement.querySelector(
        "[data-js='second-input']",
      );
      const thirdInput = customizeElement.querySelector(
        "[data-js='third-input']",
      );
      const fourthInput = customizeElement.querySelector(
        "[data-js='fourth-input']",
      );
      const firstInputLocation = customizeElement.querySelector(
        "[data-js='first-input-location']",
      );
      const secondInputLocation = customizeElement.querySelector(
        "[data-js='second-input-location']",
      );
      const thirdInputLocation = customizeElement.querySelector(
        "[data-js='third-input-location']",
      );
      const fourthInputLocation = customizeElement.querySelector(
        "[data-js='fourth-input-location']",
      );

      checkbox.addEventListener("change", () =>
        this.toggleCustomize(customizeElement, checkbox),
      );
      regularFontButton.addEventListener("click", () =>
        this.setRegularFont(inputsWrapper),
      );
      cursiveFontButton.addEventListener("click", () =>
        this.setCursiveFont(inputsWrapper),
      );
      firstInput.addEventListener("input", () =>
        this.setInputLocation(firstInput, firstInputLocation),
      );
      if (secondInput) {
        secondInput.addEventListener("input", () =>
          this.setInputLocation(secondInput, secondInputLocation),
        );
      }
      if (thirdInput) {
        thirdInput.addEventListener("input", () =>
          this.setInputLocation(thirdInput, thirdInputLocation),
        );
      }
      if (fourthInput) {
        fourthInput.addEventListener("input", () =>
          this.setInputLocation(fourthInput, fourthInputLocation),
        );
      }

      this.arrowButton.addEventListener("click", () => {
        if (this.isOpen) {
          this.closeCustomizeArea(customizeElement);
        } else {
          this.openCustomizeArea(customizeElement);
        }
      });
    });
  }

  toggleCustomize(customizeElement, checkbox) {
    // console.log(checkbox)
    if (checkbox.checked) {
      this.openCustomizeArea(customizeElement);
    } else {
      this.closeCustomizeArea(customizeElement);
    }
  }

  openCustomizeArea(customizeElement) {
    customizeElement.classList.remove("hidden");
    customizeElement.classList.add("flex");

    let mm = gsap.matchMedia();

    mm.add("(max-width: 1024px)", () => {
      if (this.isOpen) {
        return;
      } else {
        const tl = gsap.timeline();

        tl.set(this.customizeTabMobile, {
          //position: "fixed",
          bottom: 0,
          width: "100%",
        });

        tl.set(customizeElement, {
          autoAlpha: 0,
        });

        tl.set(this.arrowButton, {
          rotate: 180,
        });
        tl.to(customizeElement, {
          ease: "power2.inOut",
          duration: 0.5,
          autoAlpha: 1,
          onComplete: () => {
            this.isOpen = true;
          },
        });
      }
    });

    mm.add("(min-width: 1024px)", () => {
      const tl = gsap.timeline();

      tl.set(customizeElement, {
        autoAlpha: 0,
        height: window.innerWidth > 1024 && 0,
      });

      tl.to(customizeElement, {
        ease: "power2.inOut",
        duration: 0.5,
        autoAlpha: 1,
        height: window.innerWidth > 1024 && "auto",
      });

      gsap.to(this.scrollableContainer, {
        ease: "power2.inOut",
        duration: 0.5,
        scrollTo: customizeElement,
        onComplete: () => {
          this.isOpen = true;
        },
      });
    });
  }

  closeCustomizeArea(customizeElement) {
    let mm = gsap.matchMedia();

    mm.add("(max-width: 1024px)", () => {
      const tl = gsap.timeline();

      tl.set(this.arrowButton, {
        rotate: 0,
      });

      tl.to(customizeElement, {
        ease: "power2.inOut",
        duration: 0.2,
        autoAlpha: 0,
        onComplete: () => {
          customizeElement.classList.add("hidden");
          customizeElement.classList.remove("flex");
          gsap.set(this.customizeTabMobile, {
            position: "relative",
          });
          this.isOpen = false;
        },
      });
    });

    mm.add("(min-width: 1024px)", () => {
      const tl = gsap.timeline();

      tl.to(customizeElement, {
        ease: "power2.inOut",
        duration: 0.5,
        autoAlpha: 0,
        height: window.innerWidth > 1024 && 0,
        onComplete: () => {
          customizeElement.classList.add("hidden");
          customizeElement.classList.remove("flex");
          this.isOpen = false;
        },
      });
    });
  }

  setRegularFont(inputsWrapper) {
    inputsWrapper.classList.remove("font-cursive");
    inputsWrapper.classList.add("font-avenir");
  }

  setCursiveFont(inputsWrapper) {
    inputsWrapper.classList.remove("font-avenir");
    inputsWrapper.classList.add("font-cursive");
  }

  setInputLocation(input, inputLocation) {
    //inputLocation.textContent = input.value;
  }
}
